/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ChangeDetectionStrategy
} from '@angular/core';
import {EditAlertConfigModel} from '../../alerts-main-page/models/edit-alert-config.model';

@Component({
    selector: 'app-alert-form-footer',
    templateUrl: './alert-form-footer.component.html',
    styleUrls: ['./alert-form-footer.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AlertFormFooterComponent {
    @Input() editAlertConfig: EditAlertConfigModel;
    @Input() isViewMode: boolean;
    @Input() isValidToApply: boolean;
    @Input() hasEditPermission: boolean;
    @Output() primaryButtonAction = new EventEmitter<void>();
    @Output() secondaryButtonAction = new EventEmitter<void>();

    get primaryButtonLabel(): string {
        return this.isViewMode ? 'Edit' : 'Apply';
    }

    get secondaryButtonLabel(): string {
        return this.isViewMode ? 'Delete' : 'Discard';
    }

    get isPrimaryButtonDisabled(): boolean {
        return this.isViewMode ? true : this.isValidToApply;
    }
}
